import React, { Fragment } from 'react'
import { ExportButton, Page, Text, Table } from '@fielded/shared-ui'
import get from 'lodash/get'
import ExportImportCard from '../../../../../van-shared/components/ExportImportCard'
import { isEpnApp } from '../../../../../van-shared/utils'

const COLUMNS = [
  {
    key: 'date',
    header: 'date',
    dataKey: 'date',
    disableSort: true,
    headerClassName: 'shipment-upload-table-header__width'
  },
  {
    key: 'destinationWarehouseCode',
    header: 'destinationWarehouseCode',
    dataKey: 'destinationWarehouseCode',
    disableSort: true
  },
  {
    key: 'productId',
    header: 'productId',
    dataKey: 'productId',
    disableSort: true
  },
  {
    key: 'batchNo',
    header: 'batchNo',
    dataKey: 'batchNo',
    disableSort: true
  },
  {
    key: 'manufacturer',
    header: 'manufacturer',
    dataKey: 'manufacturer',
    disableSort: true
  },
  {
    key: 'expiry',
    header: 'expiry',
    dataKey: 'expiry',
    disableSort: true,
    headerClassName: 'shipment-upload-table-header__width'
  },
  {
    key: 'quantity',
    header: 'quantity',
    dataKey: 'quantity',
    disableSort: true
  },
  {
    key: 'programId',
    header: 'programId',
    dataKey: 'programId',
    disableSort: true
  },
  {
    key: 'funderId',
    header: 'funderId',
    dataKey: 'funderId',
    disableSort: true
  },
  {
    key: 'productCodeAlias',
    header: 'productCodeAlias',
    dataKey: 'productCodeAlias',
    disableSort: true
  }
]

const PSMInboundShipmentsOverviewDownload = ({
  country,
  isDownloading,
  onDownloadTemplate,
  warehouseCode,
  products,
  user,
  config
}) => {
  const userPrograms = Array.isArray(user.programs) ? user.programs : []
  const userFunders = Array.isArray(user.funders) ? user.funders : []
  const isEpn = isEpnApp(config)

  // Use first program/funder if available, otherwise fall back to defaults
  const programId = userPrograms.length > 0
    ? userPrograms[0]
    : `program:${country}-epn`

  const funderId = userFunders.length > 0
    ? userFunders[0]
    : `funder:${country}-epn`

  const threeProductsSample = products.slice(0, 3)
  const rows = threeProductsSample.map((product, index) => ({
    date: new Date().toISOString().split('T')[0],
    destinationWarehouseCode: warehouseCode || '',
    productId: get(product, '_id', ''),
    batchNo: '88087',
    manufacturer: 'unknown',
    expiry: '2029-01-11',
    quantity: 10,
    programId,
    funderId,
    productCodeAlias: isEpn ? 'epn' : 'none'
  }))

  return (
    <Fragment>
      <Page.Panel>
        <ExportImportCard
          title='Download shipment template'
          description='Click on the button below to download the Excel template for your shipment import. Ensure you do not modify the structure of the template to avoid upload errors.'
        >

          <Text>Here is an example how the Excel file should look:</Text>
          <div className='inbound-shipments-upload-example__wrapper vs-u-margin-bottom'>
            <Table
              entries={rows}
              columns={COLUMNS}
              headerTextStyle='lowercase'
            />
          </div>
          <Text><Text tag='span' bold>date</Text> column contains the date of the shipment in format <Text tag='span' bold>"yyyy-mm-dd"</Text> or <Text tag='span' bold>"yyyy/mm/dd"</Text></Text>
          <Text><Text tag='span' bold>destination warehouse code</Text> column contains the destination warehouse code.</Text>
          <Text><Text tag='span' bold>product Id</Text> column contains the product id</Text>
          <Text><Text tag='span' bold>batch no</Text> column contains the batch number</Text>
          <Text><Text tag='span' bold>manufacturer</Text> column contains the product manufacturer</Text>
          <Text><Text tag='span' bold>expiry</Text> column contains the batch expiry date in format <Text tag='span' bold>"yyyy-mm-dd"</Text> or <Text tag='span' bold>"yyyy/mm/dd"</Text></Text>
          <Text><Text tag='span' bold>quantity</Text> column contains the quantity to be delivered</Text>
          <Text><Text tag='span' bold>program Id</Text> column contains the identifier of the program</Text>
          <Text><Text tag='span' bold>funder Id</Text> column contains the identifier of the funder</Text>
          <Text><Text tag='span' bold>product code alias</Text> column contains the alternate product code</Text>
        </ExportImportCard>
      </Page.Panel>
      <Page.Footer fixed>
        <ExportButton
          buttonText='Download template'
          loading={isDownloading}
          filename={`shipments-${new Date().toJSON()}.xlsx`}
          onExport={onDownloadTemplate}
        />
      </Page.Footer>
    </Fragment>
  )
}

export default PSMInboundShipmentsOverviewDownload
